import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
// import { PageName } from "../../../utils/pages-helpers";
import StaffView from './staff.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useStaffRoutes = () => (
  <Route
    path={pages.staff.path}
    element={
      <ProtectedRoute module="staff" checkAnySubmodule>
        <StaffView />
      </ProtectedRoute>
    }
  >
    <Route
      index
      element={
        <ProtectedRoute module="staff" checkAnySubmodule>
          <StaffView />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute module="staff" checkAnySubmodule>
          <StaffView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useStaffRoutes;
